/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
// import { Accordion, Card } from "react-bootstrap";
// import _ from "lodash";
import Pagination from "react-js-pagination";
// import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
// import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { getInvoices, exportInvoice } from "actions";
import InvoicesTable from "components/invoices/InvoicesTable";
import { OrangeAlert } from "components/elements/alerts";
import "components/invoices/invoice.css";
import { Trans } from "react-i18next";
import i18n from "i18next";

class Invoices extends Component {
  state = {
    invoicesFetched: false,
    showYearOptions: false,
    showMonthOptions: false,
    selectedYear: parseInt(new Date().getFullYear()),
    selectedMonth: parseInt(new Date().getMonth()),
    filteredInvoicesData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
  };

  settings = {
    itemsPerPage: 10,
  };

  // monthWrapper = React.createRef();
  // yearWrapper = React.createRef();

  componentDidMount() {
    this.fetchInvoices();
  }

  componentDidUpdate = (prevProps, prevState) => {

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredInvoicesData: this.props.invoices.invoices.filter((invoice) => {
          return invoice.training.name
            .toLowerCase()
            .includes(this.state.filterTerm.toLowerCase());
        }),
      });
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();

    this.setState({
      invoicesFetched: true,
      filteredInvoicesData: this.props.invoices.invoices,
    });
  };

  onExportSuccess = (res, fname) => {
    this.props.onProcessEnd();
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fname);
    document.body.appendChild(link);
    link.click();
  };

  fetchInvoices = () => {
    this.props.getInvoices(
      this.state.selectedMonth + 1,
      this.state.selectedYear,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };
  handleExport = () => {
    this.props.exportInvoice(
      this.state.selectedMonth + 1,
      this.state.selectedYear,
      this.onBegin,
      this.onExportSuccess,
      this.onError
    );
  };

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleClickOutsideMonth = (e) => {
    if (this.state.showMonthOptions) this.toggleMonthSelection();
  };

  handleClickOutsideYear = (e) => {
    if (this.state.showYearOptions) this.toggleYearSelection();
  };

  handleFetch = () => {
    this.setState({ invoicesFetched: false });
    this.fetchInvoices();
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  handleYearSelected = (y) => {
    this.toggleYearSelection();
    this.setState({ selectedYear: y });
  };

  toggleYearSelection = () => {
    let tmp = this.state.showYearOptions;
    this.setState({ showYearOptions: !tmp, showMonthOptions: false });
  };
  renderSelectableYears = () => {
    if (!this.state.showYearOptions) {
      return null;
    }

    let date = new Date();
    let yearsJsx = [];
    for (
      let y = parseInt(date.getFullYear());
      y >= parseInt(date.getFullYear()) - 4;
      y--
    ) {
      yearsJsx.push(
        <span
          key={y}
          onClick={() => this.handleYearSelected(y)}
          className="custom-option personalTableType selected"
        >
          {y}
        </span>
      );
    }

    return (
      <div
        className="custom-options"
        style={{ visibility: "visible", opacity: "1", pointerEvents: "all" }}
      >
        {yearsJsx}
      </div>
    );
  };

  handleMonthSelected = (m) => {
    this.toggleMonthSelection();
    this.setState({ selectedMonth: m });
  };

  toggleMonthSelection = () => {
    let tmp = this.state.showMonthOptions;
    this.setState({ showMonthOptions: !tmp, showYearOptions: false });
  };
  renderSelectableMonths = () => {
    if (!this.state.showMonthOptions) {
      return null;
    }

    let monthsJsx = [];
    for (let m = 0; m <= 11; m++) {
      monthsJsx.push(
        <span
          key={m}
          onClick={() => this.handleMonthSelected(m)}
          className="custom-option personalTableType selected"
        >
          {new Date(2020, m, 1).toLocaleString(localStorage.getItem("i18nextLng"), { month: "long" })}
        </span>
      );
    }

    return (
      <div
        id="month-options"
        className="custom-options"
        style={{ visibility: "visible", opacity: "1", pointerEvents: "all" }}
      >
        {monthsJsx}
      </div>
    );
  };

  renderTableToolbar = () => {
    return (
      <div className="row align-items-center py-3 eduTitleArea">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
              <div className="inner-addon right-addon">
                <span className="iconmford fo-icon-search"></span>
                <input
                  type="text"
                  name="tableSearch"
                  id="tableSearch"
                  className="form-control"
                  placeholder={i18n.t("10053")}
                  onChange={(e) => this.handleFilter(e)}
                  value={this.state.filterTerm}
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 tableCategoryArea">
              {/* <OutsideClickAvare
                handleClickOutside={this.handleClickOutsideMonth}
              > */}
              <div
                className="custom-select-wrapper my-ft"
                ref={this.monthWrapper}
                onBlur={this.handleClickOutsideMonth}
                tabIndex="0"
              >
                <div className="custom-select">
                  <div
                    className="custom-select__trigger"
                    onClick={this.toggleMonthSelection}
                  >
                    <span>
                      {new Date(
                        2020,
                        this.state.selectedMonth,
                        1
                      ).toLocaleString(localStorage.getItem("i18nextLng"), { month: "long" })}
                    </span>
                    <span className="iconmford fo-icon-expand-more"></span>
                  </div>
                  {this.renderSelectableMonths()}
                </div>
              </div>
              {/* </OutsideClickAvare> */}
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 tableCategoryArea">
              <div
                className="custom-select-wrapper my-ft"
                ref={this.yearWrapper}
                onBlur={this.handleClickOutsideYear}
                tabIndex="0"
              >
                <div className="custom-select">
                  <div
                    className="custom-select__trigger"
                    onClick={this.toggleYearSelection}
                  >
                    <span>{this.state.selectedYear}</span>
                    <span className="iconmford fo-icon-expand-more"></span>
                  </div>
                  {this.renderSelectableYears()}
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 tableCategoryArea">
              <div className="inner-addon right-addon">
                <button
                  type="button"
                  className="talepEtBtn"
                  style={{ width: "100%" }}
                  onClick={this.handleFetch}
                >
                  <Trans desc="Filtrele">10112</Trans>
                </button>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2 tableCategoryArea">
              <div className="inner-addon right-addon">
                <button
                  type="button"
                  className="talepEtBtn"
                  style={{ width: "100%" }}
                  onClick={this.handleExport}
                >
                  <Trans desc="Dışa Aktar">10113</Trans>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPager = () => {
    return (
      <div
        style={{
          display: "grid",
          justifyContent: "right",
          marginRight: "20px",
        }}
      >
        <Pagination
          hideFirstLastPages={true}
          prevPageText="Önceki"
          nextPageText="Sonraki"
          hideDisabled={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={this.state.filteredInvoicesData.length}
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  render() {
    if (!this.state.invoicesFetched) {
      return this.props.spinner;
    }

    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    return (
      <section className="sssArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Faturalar">10033</Trans>
                </li>
              </ul>
            </div>
          </div>
          {this.renderTableToolbar()}

          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <InvoicesTable
                data={this.state.filteredInvoicesData.slice(start, end)}
              />
              {/* {console.log(this.props.invoices.data.invoices)} */}
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-0 col-sm-0 col-md-9 col-lg-9"></div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              {this.renderPager()}
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <OrangeAlert
                desc="Dikkat! Katılım sonucu 'Katılmadı'..."
                content={i18n.t("10126")}
              />
            </div>
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div className="fgaAlert" style={{ backgroundColor: "#e6f3f9" }}>
                <div className="invoiceSummary">
                  <div className="invoiceSummaryLabel tableTitle">
                    <Trans desc="Toplam">10123</Trans>:
                  </div>
                  <div className="tableTitle invoiceSummaryValue">
                    {this.props.invoices.totalPrice} <sup>TL</sup>
                  </div>
                  <div></div>
                  <div className="invoiceSummaryLabel tableTitle">
                    <Trans desc="kdv">10125</Trans>:
                  </div>
                  <div className="tableTitle invoiceSummaryValue">
                    {this.props.invoices.kdvPrice} <sup>TL</sup>
                  </div>
                  <div></div>
                  <div className="invoiceSummaryLabel tableTitle">
                    <Trans desc="Genel Toplam">10124</Trans>:
                  </div>
                  <div className="tableTitle invoiceSummaryValue">
                    {this.props.invoices.totalPriceWithKDV} <sup>TL</sup>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ invoices, application }) => {
  return {
    invoices: invoices.data.data,
    application,
  };
};

export default connect(mapStateToProps, { getInvoices, exportInvoice })(
  containsLongRunningProcess(requireAuth(Invoices))
);
